import { MAX_ORTSPFAD } from "@stammbaum/shared";
import { useOrtsvorschlaege } from "./ortsvorschlaege";

/**
 * Ein Ortsfeld mit Vorschlagsliste - in allen Masken dasselbe.
 *
 * Steht in drei Masken (Person, Ereignis, Bild), und die Personenmaske hat
 * es sogar zweimal: Geburtsort und Wohnort. Jedes Feld bekommt seine eigene
 * Vorschlagsliste, denn die haengt am zuletzt Getippten - eine gemeinsame
 * hiesse, dass im Wohnort Krems-Vorschlaege stehen, weil oben der Geburtsort
 * Krems eingetippt wurde.
 *
 * Der ganze Pfad ist der Wert jedes Vorschlags („Haimschlag 30, Echsenbach,
 * Niederoesterreich"): ein Klick traegt ihn ein, und die Eingabe trifft damit
 * genau diesen Ort. Der blosse Name waere bei zwei gleichnamigen Orten
 * zweimal derselbe Eintrag - und wer dann selbst tippt, legt die dritte
 * Dublette an.
 */
export function OrtFeld({
  beschriftung,
  id,
  wert,
  onChange,
  platzhalter,
  klasseFeld,
  klasseBeschriftung,
}: {
  beschriftung: string;
  /** Muss je Feld verschieden sein - verbindet Eingabe und Liste. */
  id: string;
  wert: string;
  onChange: (text: string) => void;
  platzhalter?: string;
  klasseFeld: string;
  klasseBeschriftung: string;
}) {
  const { orte, abgeschnitten, treffer, tippen } = useOrtsvorschlaege();

  return (
    <label className="block">
      <span className={klasseBeschriftung}>{beschriftung}</span>
      <input
        value={wert}
        onChange={(e) => {
          onChange(e.target.value);
          tippen(e.target.value);
        }}
        maxLength={MAX_ORTSPFAD}
        list={id}
        placeholder={platzhalter}
        className={klasseFeld}
      />
      <datalist id={id}>
        {orte.map((o) => (
          <option key={o.id} value={o.pfad} label={o.plz ? `PLZ ${o.plz}` : undefined} />
        ))}
      </datalist>
      {abgeschnitten && (
        // Ohne diesen Satz entsteht genau der Eindruck, der die Dubletten
        // gemacht hat: „den Ort gibt es doch, warum finde ich ihn nicht."
        <span className="mt-1 block text-xs text-black/40 dark:text-white/40">
          {treffer} Treffer — es werden die meistbenutzten gezeigt, weitertippen grenzt ein.
        </span>
      )}
    </label>
  );
}
